<template>
  <b-container v-show="showWildcard" v-if="wildcard" class="my-5" fluid>
    <b-row class="wildcard-container py-5 position-relative">
      <button id="close-wildcard" class="close" @click="closeWildcard">×</button>
      <b-col class="wildcard" cols="12" md="8">
        <img
          src="https://cdn.vexels.com/img/seeker-man.png"
          :alt="$t('withoutResult.main.wildcard.seekerManAlt')"
          loading="lazy"
        />
        <div class="text-container">
          <p>
            {{ $t('withoutResult.main.wildcard.firstText', { dimension: getActualDimensionName }) }}
            <span class="font-weight-bold">{{ actualSearch }}</span>
            {{
              $t('withoutResult.main.wildcard.secondText', { dimension: getActualDimensionName })
            }}
            <span class="font-weight-bold">{{ actualSearch }}</span>
            {{ $t('withoutResult.main.wildcard.thirdText') }}
            <nuxt-link :to="requestLink" class="to-profile">
              {{ $t('withoutResult.main.wildcard.link') }}
            </nuxt-link>
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  data() {
    return {
      showWildcard: true
    };
  },
  computed: {
    ...mapGetters('dimensions', ['getActualDimensionName']),
    ...mapState('search', ['wildcard']),
    actualSearch() {
      return this.$route.params.search ? this.$route.params.search.replace(/-/g, ' ') : '';
    },
    requestLink() {
      const link = this.$auth.loggedIn
        ? this.localePath('profile-my-requests-new')
        : this.$urlBuilder('landing', { uid: 'design-requests' });
      return link;
    }
  },
  methods: {
    closeWildcard() {
      this.showWildcard = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#close-wildcard {
  position: absolute;
  right: 15px;
  top: 10px;
  font-weight: 400;
  font-size: 2em;

  &:focus {
    border: none;
    outline: none;
  }
}
.wildcard-container {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}
.wildcard {
  margin: auto;
  transition: 0.5s width;
  display: flex;
  align-items: center;
}
.wildcard img {
  width: 40%;
}
.wildcard .text-container {
  padding: 0 50px;
}
.wildcard .text-container p {
  font-size: 30px;
  color: #989898;
}
.wildcard .text-container p a {
  color: #3cd699;
  border-bottom: 2px solid #3cd699;
}

@media all and (max-width: 1500px) {
  .wildcard {
    width: 70%;
  }
}
@media all and (max-width: 1200px) {
  .wildcard {
    width: 80%;
  }
  .wildcard .text-container {
    padding: 0 0 0 50px;
  }
  .wildcard .text-container p {
    font-size: 25px;
  }
}
@media all and (max-width: 1000px) {
  .wildcard {
    width: 90%;
  }
}
@media all and (max-width: 900px) {
  .wildcard {
    width: 100%;
  }
  .wildcard .text-container p {
    font-size: 20px;
  }
}
@media all and (max-width: 767px) {
  .wildcard {
    display: block;
    text-align: center;
  }
  .wildcard .text-container {
    padding: 0;
    margin: auto;
    margin-top: 25px;
    text-align: left;
  }
}
@media all and (max-width: 576px) {
  .wildcard .text-container {
    width: 95%;
  }
  .wildcard img {
    width: 60%;
  }
}
@media all and (max-width: 400px) {
  .wildcard img {
    width: 90%;
  }
}
</style>
